import React, { useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import api from '../../services/api'; 

// On extrait l'URL de base de façon sécurisée
const getSocketUrl = () => {
  try {
    const baseUrl = api.defaults?.baseURL || "";
    if (!baseUrl) return "";
    
    // On crée un objet URL pour manipuler l'adresse proprement
    const url = new URL(baseUrl);
    // On retourne l'origine (ex: https://frequence974.gaelprod974.re)
    return url.origin;
  } catch (e) {
    console.error("Erreur de configuration URL dans api.js");
    return "";
  }
};

const SOCKET_URL = getSocketUrl();

const StatCard = ({ title, value, trend, color, isLive }) => (
  <div className={`card bg-dark border-0 shadow-lg rounded-5 p-4 border-start border-4 ${color.replace('text', 'border')} h-100`}>
    <h6 className="text-secondary fw-black text-uppercase small tracking-widest mb-3" style={{ fontSize: '10px' }}>
      {title}
    </h6>
    <div className="d-flex justify-content-between align-items-end">
      <h2 className={`display-6 fw-black mb-0 ${color} tracking-tighter`}>
        {value}
      </h2>
      <span className={`badge ${isLive ? 'bg-danger animate-pulse text-white' : 'bg-secondary bg-opacity-25 text-white-50'} p-2 rounded-3 fw-bold`} style={{ fontSize: '10px' }}>
        {isLive && <span className="me-1">●</span>}
        {trend}
      </span>
    </div>

    {isLive && (
      <style>{`
        .animate-pulse {
          animation: pulse-red 2s infinite;
        }
        @keyframes pulse-red {
          0% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4); }
          70% { box-shadow: 0 0 0 10px rgba(220, 53, 69, 0); }
          100% { box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
        }
      `}</style>
    )}
  </div>
);

const StatCards = ({ videoCount, partnerCount }) => {
  const [liveUsers, setLiveUsers] = useState(0);

  useEffect(() => {
    if (!SOCKET_URL) return;

    const socket = io(SOCKET_URL, {
      transports: ['polling', 'websocket'],
      reconnectionAttempts: 3
    });

    socket.on('user_count', (count) => {
      setLiveUsers(count);
    });

    socket.on('connect_error', () => {
      // Log propre sans erreur bloquante
      console.log("Flux live non détecté sur :", SOCKET_URL);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <div className="row g-3 g-md-4">
      <div className="col-12 col-md-4">
        <StatCard 
          title="Auditeurs Direct" 
          value={liveUsers} 
          trend="LIVE" 
          color="text-danger" 
          isLive={true} 
        />
      </div>
      <div className="col-12 col-md-4">
        <StatCard 
          title="Total Replays" 
          value={videoCount} 
          trend="Stable" 
          color="text-info" 
          isLive={false} 
        />
      </div>
      <div className="col-12 col-md-4">
        <StatCard 
          title="Total Partenaires" 
          value={partnerCount} 
          trend="Réseau" 
          color="text-primary" 
          isLive={false} 
        />
      </div>
    </div>
  );
};

export default StatCards;